import { createContext, Dispatch, SetStateAction } from 'react';

export type TenantContextType = [string | null, Dispatch<SetStateAction<string | null>>] | null;

export const TenantContext = createContext<TenantContextType>(null);
